import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { transformSDKTimestampToRESTTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformSDKFieldMaskToRESTFieldMask } from '@wix/sdk-runtime/transformations/field-mask';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlRestaurantsMenusSiteUrlUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressRestaurantsMenusMenuV1RestaurantsDuplicateMenuRestaurantsDuplicateMenuUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

function resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'manage._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    _: [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
    ],
    'www._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/restaurants-menus-menu',
        destPath: '',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/restaurants/menus-menu',
        destPath: '',
      },
      {
        srcPath: '/restaurants/menus/v1/bulk/menus',
        destPath: '/v1/bulk/menus',
      },
      {
        srcPath: '/restaurants/menus/v1/menus',
        destPath: '/v1/menus',
      },
    ],
    'apps._base_domain_': [
      {
        srcPath: '/_api/restaurants-menus-menu',
        destPath: '',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_restaurants_menus';

/**
 * > **Note:** The Menus API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates a menu.
 *
 * To create multiple menus at once, use [Bulk Create Menus](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/bulk-create-menus).
 */
export function createMenu(payload: object): RequestOptionsFactory<any> {
  function __createMenu({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'menu.createdDate' },
          { path: 'menu.updatedDate' },
          { path: 'menu.externalReferenceInfo.lastSyncDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.CreateMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/menus',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'menu.createdDate' },
              { path: 'menu.updatedDate' },
              { path: 'menu.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __createMenu;
}

/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates multiple menus at once.
 */
export function bulkCreateMenus(payload: object): RequestOptionsFactory<any> {
  function __bulkCreateMenus({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'menus.createdDate' },
          { path: 'menus.updatedDate' },
          { path: 'menus.externalReferenceInfo.lastSyncDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.BulkCreateMenus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/bulk/menus/create',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.menu.createdDate' },
              { path: 'results.menu.updatedDate' },
              { path: 'results.menu.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkCreateMenus;
}

/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a menu by ID.
 */
export function getMenu(payload: object): RequestOptionsFactory<any> {
  function __getMenu({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.GetMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/menus/{menuId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'menu.createdDate' },
              { path: 'menu.updatedDate' },
              { path: 'menu.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __getMenu;
}

/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 500 menus.
 */
export function listMenus(payload: object): RequestOptionsFactory<any> {
  function __listMenus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.ListMenus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/menus',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'menus.createdDate' },
              { path: 'menus.updatedDate' },
              { path: 'menus.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __listMenus;
}

/**
 * Creates a query to retrieve a list of menus.
 *
 * The `queryMenus()` function builds a query to retrieve a list of menus and returns a `MenusQueryBuilder` object.
 *
 * The returned object contains the query definition, which is used to run the query using the [`find()`](/menus/menus-query-builder/find) function.
 *
 * You can refine the query by chaining `MenusQueryBuilder` functions onto the query. `MenusQueryBuilder` functions enable you to filter, sort, and control the results that `queryMenus()` returns.
 *
 * `queryMenus()` runs with the following `MenusQueryBuilder` defaults, which you can override:
 *
 * * [`limit(100)`](/menus/menus-query-builder/limit)
 *
 * The following `MenusQueryBuilder` functions are supported for `queryMenus()`. For a full description of the menu object, see the object returned for the [`items`](/menus/menus-query-result/items) property in `MenusQueryResult`.
 */
export function queryMenus(payload: object): RequestOptionsFactory<any> {
  function __queryMenus({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.QueryMenus',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/menus/query',
        data: payload,
        host,
      }),
      data: payload,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'menus.createdDate' },
              { path: 'menus.updatedDate' },
              { path: 'menus.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __queryMenus;
}

/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates a menu.
 *
 * To update multiple menus at once, use [Bulk Update Menu](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/menu/bulk-update-menu).
 *
 * Each time a menu is updated, its revision increments by 1. The existing revision must be included when updating a menu. This ensures you're working with the latest menu information, and it prevents unintended overwrites.
 */
export function updateMenu(payload: object): RequestOptionsFactory<any> {
  function __updateMenu({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'menu.createdDate' },
          { path: 'menu.updatedDate' },
          { path: 'menu.externalReferenceInfo.lastSyncDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'PATCH' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.UpdateMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/menus/{menu.id}',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'menu.createdDate' },
              { path: 'menu.updatedDate' },
              { path: 'menu.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __updateMenu;
}

/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates multiple menus at once.
 *
 * Each time a menu is updated, its revision increments by 1. The existing revision must be included when updating the menu. This ensures you're working with the latest menu information, and it prevents unintended overwrites.
 */
export function bulkUpdateMenu(payload: object): RequestOptionsFactory<any> {
  function __bulkUpdateMenu({ host }: any) {
    const serializedData = transformPaths(payload, [
      {
        transformFn: transformSDKFieldMaskToRESTFieldMask,
        paths: [{ path: 'menus.mask' }],
      },
      {
        transformFn: transformSDKTimestampToRESTTimestamp,
        paths: [
          { path: 'menus.menu.createdDate' },
          { path: 'menus.menu.updatedDate' },
          { path: 'menus.menu.externalReferenceInfo.lastSyncDate' },
        ],
      },
    ]);
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.BulkUpdateMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/bulk/menus/update',
        data: serializedData,
        host,
      }),
      data: serializedData,
      transformResponse: (payload: any) =>
        transformPaths(payload, [
          {
            transformFn: transformRESTTimestampToSDKTimestamp,
            paths: [
              { path: 'results.menu.createdDate' },
              { path: 'results.menu.updatedDate' },
              { path: 'results.menu.externalReferenceInfo.lastSyncDate' },
            ],
          },
        ]),
    };

    return metadata;
  }

  return __bulkUpdateMenu;
}

/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates only the `extendedFields` field.
 */
export function updateExtendedFields(
  payload: object
): RequestOptionsFactory<any> {
  function __updateExtendedFields({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.UpdateExtendedFields',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/menus/{id}/updateExtendedFields',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __updateExtendedFields;
}

/**
 * > **Note:** The Menu API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes a menu.
 */
export function deleteMenu(payload: object): RequestOptionsFactory<any> {
  function __deleteMenu({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'DELETE' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.RestaurantsMenusMenu.DeleteMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusMenuUrl({
        protoPath: '/v1/menus/{menuId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __deleteMenu;
}

export function duplicateMenu(payload: object): RequestOptionsFactory<any> {
  function __duplicateMenu({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.restaurants_duplicate_menu.RestaurantsDuplicateMenu.DuplicateMenu',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsDuplicateMenuRestaurantsDuplicateMenuUrl(
        { protoPath: '/v1/menus/{id}/duplicate', data: payload, host }
      ),
      data: payload,
    };

    return metadata;
  }

  return __duplicateMenu;
}

/** Get menu details and path URL by menu ID. */
export function getMenuSiteUrl(payload: object): RequestOptionsFactory<any> {
  function __getMenuSiteUrl({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'GET' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.restaurants_menus_site_url.RestaurantsMenusSiteUrl.GetMenuSiteUrl',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlRestaurantsMenusSiteUrlUrl(
        { protoPath: '/v1/menus-site-url/menus/{id}', data: payload, host }
      ),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getMenuSiteUrl;
}

/** Query menu details and path URL */
export function queryMenusSiteUrl(payload: object): RequestOptionsFactory<any> {
  function __queryMenusSiteUrl({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.restaurants.menus.v1.menu',
      method: 'POST' as any,
      methodFqn:
        'com.wixpress.restaurants.menus_menu.v1.restaurants_menus_site_url.RestaurantsMenusSiteUrl.QueryMenusSiteUrl',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixpressRestaurantsMenusMenuV1RestaurantsMenusSiteUrlRestaurantsMenusSiteUrlUrl(
        { protoPath: '/v1/menus-site-url/menus/query', data: payload, host }
      ),
      data: payload,
    };

    return metadata;
  }

  return __queryMenusSiteUrl;
}
